export interface CheckboxOptions {
  value:string;
}

export interface CheckboxValue {
  value: string | number;
  checked: boolean;
}
